import * as Apollo from "@apollo/client";
import { pipe, TaskEither } from "fp";
import { QueryKey } from "react-query";
import { Reference } from "~/Data";
import * as ErrorMessage from "~/ErrorMessage";
import { Request } from "~/Request";
import { WebAPI } from "~/WebAPI";

import { Revision } from "../..";

export namespace Query {
  export const tag = () => "Suggested Revisions" as const;

  export type QueryIdParams = {
    readonly driver: Reference.Reference;
  };

  export const key = ({ driver }: QueryIdParams): QueryKey => [
    tag(),
    `${driver.id}`,
  ];

  export const request = (client: Apollo.ApolloClient<unknown>) => (
    driver: Reference.Reference
  ): Request.Fn<readonly Revision.Revision[]> => () =>
    pipe(
      TaskEither.fromUnsafe(() =>
        client.query<
          WebAPI.Revision.SuggestedRevisionsResult,
          WebAPI.Revision.SuggestedRevisionsVariables
        >({
          query: WebAPI.Revision.SuggestedRevisionsDocument,
          variables: { driverId: Number(driver.id) },
          fetchPolicy: "network-only",
        })
      ),
      TaskEither.mapLeft((error) => {
        console.error(error);
        return Error(
          `Something is wrong with your connection, ${ErrorMessage.Remedy.Retry.later()} or ${ErrorMessage.Remedy.contactSupport()}.`
        );
      }),
      TaskEither.map((result) => result.data.suggestedRevisions),
      TaskEither.map(Revision.Request.decodeArrayFromGQL(driver))
    );
}
